"use client";

import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
import { useRouter } from "next/navigation";
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type HorizontalNewsItem = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
type Props = HorizontalNewsItem & {
  data?: HorizontalNewsItem[];
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
function HorizontalBigImageCategoryNewsHome(t0) {
  const $ = _c(43);
  const {
    data,
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    priority: t6,
    imageMetadata,
    templatetype: t7,
    isliveblog: t8
  } = t0;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? {
      hidden: false,
      value: "INDIA",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const category = t9;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? {
      hidden: false,
      value: "\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE\u0BB5\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B89\u0BB1\u0BCD\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF 8.5 \u0B9A\u0BA4\u0BB5\u0BC0\u0BA4\u0BAE\u0BCD \u0B85\u0BA4\u0BBF\u0B95\u0BB0\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1; \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B85\u0BAE\u0BC8\u0B9A\u0BCD\u0B9A\u0B95\u0BAE\u0BCD",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const title = t10;
  let t11;
  if ($[4] !== t3) {
    t11 = t3 === undefined ? {
      hidden: false,
      value: "\u0BA8\u0BBE\u0B9F\u0BCD\u0B9F\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B89\u0BB1\u0BCD\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF 2023 \u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BBF\u0BB2\u0BCD 8.5 \u0B9A\u0BA4\u0BB5\u0BC0\u0BA4\u0BAE\u0BCD \u0B85\u0BA4\u0BBF\u0B95\u0BB0\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 73.14 \u0B95\u0BCB\u0B9F\u0BBF \u0B9F\u0BA9\u0BCD\u0BA9\u0BBE\u0B95",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const excerpt = t11;
  let t12;
  if ($[6] !== t4) {
    t12 = t4 === undefined ? {
      hidden: false,
      value: "15 min ago",
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  const timeAgo = t12;
  let t13;
  if ($[8] !== t5) {
    t13 = t5 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t5;
    $[8] = t5;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const imageSrc = t13;
  const priority = t6 === undefined ? false : t6;
  let t14;
  if ($[10] !== t7) {
    t14 = t7 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t7;
    $[10] = t7;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const templatetype = t14;
  let t15;
  if ($[12] !== t8) {
    t15 = t8 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t8;
    $[12] = t8;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  const isliveblog = t15;
  let t16;
  if ($[14] !== category || $[15] !== data || $[16] !== excerpt || $[17] !== imageSrc || $[18] !== isliveblog || $[19] !== sectionUrl || $[20] !== slug || $[21] !== templatetype || $[22] !== timeAgo || $[23] !== title) {
    t16 = data ?? [{
      category,
      title,
      excerpt,
      timeAgo,
      imageSrc,
      slug,
      sectionUrl,
      templatetype,
      isliveblog
    }];
    $[14] = category;
    $[15] = data;
    $[16] = excerpt;
    $[17] = imageSrc;
    $[18] = isliveblog;
    $[19] = sectionUrl;
    $[20] = slug;
    $[21] = templatetype;
    $[22] = timeAgo;
    $[23] = title;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  const items = t16;
  const router = useRouter();
  let t17;
  if ($[25] !== router || $[26] !== sectionUrl) {
    t17 = (e, itemSectionUrl) => {
      const url = itemSectionUrl || sectionUrl;
      if (url) {
        e.preventDefault();
        e.stopPropagation();
        router.push(url);
      }
    };
    $[25] = router;
    $[26] = sectionUrl;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const handleCategoryClick = t17;
  let t18;
  if ($[28] !== handleCategoryClick || $[29] !== imageMetadata || $[30] !== isliveblog?.value || $[31] !== priority || $[32] !== sectionUrl || $[33] !== templatetype?.value) {
    t18 = item => {
      const categoryValue = toFieldString(item.category?.value);
      const titleValue = toFieldString(item.title?.value);
      const excerptValue = toFieldString(item.excerpt?.value);
      const timeValue = getTimeAgo(toFieldString(item.timeAgo?.value));
      const imageSrcValue = getImageUrl(toFieldString(item.imageSrc?.value)) || FALLBACK_IMAGE;
      const itemSectionUrl_0 = item.sectionUrl;
      const isLiveBlog = isLiveBlogValue(item.templatetype?.value ?? templatetype?.value) || isLiveBlogValue(item.isliveblog?.value ?? isliveblog?.value);
      return <article className="text-FFFFFF p-4 mb-0 align-center cursor-pointer"><div className="flex flex-col md:flex-row gap-4">{!item.imageSrc?.hidden && <div className={`w-full md:w-5/12 lg:w-2.9/5 shrink-0 ${item.imageSrc?.customClass || ""}`}><div className="relative w-full aspect-[16/9] md:aspect-auto md:h-[230px] overflow-hidden" style={{
              contain: "layout"
            }}><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px" className="object-cover" style={getFocusPointStyle(item.imageMetadata ?? imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>}<div className="flex flex-col justify-between lg:min-h-[220px] w-full"><div className="flex flex-col gap-3">{!item.category?.hidden && <>{itemSectionUrl_0 || sectionUrl ? <span className={`text-14-tamil-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${item.category?.customClass || ""}`} onClick={e_0 => handleCategoryClick(e_0, itemSectionUrl_0)}>{categoryValue}</span> : <div className={`text-14-tamil-600 text-012061 tracking-wide uppercase ${item.category?.customClass || ""}`}>{categoryValue}</div>}</>}{!item.title?.hidden && <h3 className={`text-24-tamil-700 md:text-14-tamil-700 hbicnh-title text-012061 font-medium leading-[1.4] ${item.title?.customClass || ""}`}>{isLiveBlog && <LiveBlink />}{titleValue}</h3>}{!item.excerpt?.hidden && <p className={`text-16-tamil-400 hbicnh-excerpt text-4D4D4D leading-[1.4] line-clamp-2 ${item.excerpt?.customClass || ""}`}>{excerptValue}</p>}</div><div className="mt-3"><div className="flex items-center justify-between">{!item.timeAgo?.hidden && <span className={`text-12-english-500 text-1B1B1B ${item.timeAgo?.customClass || ""}`}>{timeValue}</span>}<MessageIcon id="image-news-message-icon" slug={item.slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={item.slug ? `/${item.slug}` : undefined} /></div></div></div></div></article>;
    };
    $[28] = handleCategoryClick;
    $[29] = imageMetadata;
    $[30] = isliveblog?.value;
    $[31] = priority;
    $[32] = sectionUrl;
    $[33] = templatetype?.value;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const renderCard = t18;
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <style>{"\n        @media (max-width: 767px) {\n          .hbicnh-title { font-size: 20px !important; font-weight: 700 !important; font-family: var(--font-tamil) !important; }\n          .hbicnh-excerpt { font-size: 14px !important; font-weight: 400 !important; font-family: var(--font-tamil) !important; }\n        }\n      "}</style>;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== items || $[37] !== renderCard) {
    let t21;
    if ($[39] !== renderCard) {
      t21 = (item_0, index) => {
        const card = renderCard(item_0);
        const key = item_0.slug || `${item_0.title?.value || "item"}-${index}`;
        if (item_0.slug) {
          return <Link key={key} href={`/${item_0.slug}`} className="block  transition-colors cursor-pointer">{card}</Link>;
        }
        return <div key={key}>{card}</div>;
      };
      $[39] = renderCard;
      $[40] = t21;
    } else {
      t21 = $[40];
    }
    t20 = items.map(t21);
    $[36] = items;
    $[37] = renderCard;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[41] !== t20) {
    t21 = <div className="space-y-4">{t19}{t20}</div>;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
}

// Memoize to prevent unnecessary re-renders
export default memo(HorizontalBigImageCategoryNewsHome);